<template>
  <textarea
    class="materialize-textarea"
    v-bind="myAttrs"
    :id="id"
    :disabled="disabled"
    :name="name"
    :value="modelValue"
    ref="textarea"
    @input="$emit('update:modelValue', $event.target.value)"
  />
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    modelValue: {
      type: String
    },
    disabled: {
      type: Boolean
    },
    name: {
      type: String
    },
    id: {
      type: String
    }
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
  computed: {
    myAttrs() {
      const { onInput, ...attrs } = this.$attrs; // exclude `input`-listener
      return attrs;
    }
  }
};
</script>

<style lang="scss" scoped></style>
